import { HeadingMedium, Label1 } from 'baseui/typography';
import React from 'react';
import { connect } from 'react-redux';
import { Bar, BarChart, CartesianGrid, Legend, ReferenceLine, Tooltip, XAxis, YAxis } from 'recharts';
import ScenarioDataBuilder from '../../calculations/social/ScenarioBuilder';
import { formatter } from '../../calculations/SocialSecurityApi';
import { colors } from './GraphData';

export const CumulativeGraph = ({ type, mainHealth, spouseHealth, answers, width=1000, height=500 }) => {
    let scenarioBuilder = new ScenarioDataBuilder(answers);
    let data;
    if (type === 'main') {
        data = scenarioBuilder.buildMainProjections();
    } else {
        data = scenarioBuilder.buildSpouseProjections();
    }

    //TODO what about already taking

    return <div style={{ width: width + 100, justifyContent: 'center', margin: 50 }}>
        <HeadingMedium>Cumulative Comparison</HeadingMedium>

        <Label1>Illustrated below is a comparison between the cumulative amounts you will have received at each respective year,
        depending on when you choose to turn social security on.</Label1>

        <Label1>The red line illustrates the average mortality in the United States. You indicated that you have {' '}
            {type === 'spouse' ? spouseHealth[0]['id'] : mainHealth[0]['id']} health, so consider this when you are choosing your benefit.</Label1>
        <br></br>
        <BarChart
            width={width}
            height={height}
            data={data.graphData}
            margin={{
                top: 5, right: 0, left: 40, bottom: 5,
            }}
        >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="age" />
            <YAxis tickFormatter={(value) => '$' + formatter.format(value)} />
            <Tooltip formatter={(value) => '$' + formatter.format(value)} />
            <Legend />
            <ReferenceLine x="85" stroke="red" strokeWidth={4} />
            {
                Object.keys(data.raw).map((elem, index) => <Bar dataKey={elem} fill={colors[index]} name={"Start at " + data.raw[elem].age} />)
            }
        </BarChart>
    </div>
}

export default connect(state => ({
    mainHealth: state.userData.answers.mainHealth,
    spouseHealth: state.userData.answers.spouseHealth,
    answers: state.userData.answers,
}), {})(CumulativeGraph);